// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsConsentController from "./analytics_consent_controller"
application.register("analytics-consent", AnalyticsConsentController)

import AnalyticsPreferencesController from "./analytics_preferences_controller"
application.register("analytics-preferences", AnalyticsPreferencesController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CodeCopyController from "./code_copy_controller"
application.register("code-copy", CodeCopyController)

import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)

import DashboardGridController from "./dashboard_grid_controller"
application.register("dashboard-grid", DashboardGridController)

import DashboardRefreshController from "./dashboard_refresh_controller"
application.register("dashboard-refresh", DashboardRefreshController)

import DashboardWidgetBuilderController from "./dashboard_widget_builder_controller"
application.register("dashboard-widget-builder", DashboardWidgetBuilderController)

import DeleteConfirmationController from "./delete_confirmation_controller"
application.register("delete-confirmation", DeleteConfirmationController)

import DocsTocController from "./docs_toc_controller"
application.register("docs-toc", DocsTocController)

import EmailDecoderController from "./email_decoder_controller"
application.register("email-decoder", EmailDecoderController)

import HeaderActionsController from "./header_actions_controller"
application.register("header-actions", HeaderActionsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstallationCheckController from "./installation_check_controller"
application.register("installation-check", InstallationCheckController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LiveChartController from "./live_chart_controller"
application.register("live-chart", LiveChartController)

import LiveListController from "./live_list_controller"
application.register("live-list", LiveListController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import OnCallCalendarController from "./on_call_calendar_controller"
application.register("on-call-calendar", OnCallCalendarController)

import PageViewBeaconController from "./page_view_beacon_controller"
application.register("page-view-beacon", PageViewBeaconController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import RecurrencePickerController from "./recurrence_picker_controller"
application.register("recurrence-picker", RecurrencePickerController)

import ReplayController from "./replay_controller"
application.register("replay", ReplayController)

import RevealOnValueController from "./reveal_on_value_controller"
application.register("reveal-on-value", RevealOnValueController)

import RowMenusController from "./row_menus_controller"
application.register("row-menus", RowMenusController)

import ScrollableRegionController from "./scrollable_region_controller"
application.register("scrollable-region", ScrollableRegionController)

import SessionReplayPlayerController from "./session_replay_player_controller"
application.register("session-replay-player", SessionReplayPlayerController)

import SettingsNavController from "./settings_nav_controller"
application.register("settings-nav", SettingsNavController)

import ShortLabelController from "./short_label_controller"
application.register("short-label", ShortLabelController)

import StrictPrivacyConfirmController from "./strict_privacy_confirm_controller"
application.register("strict-privacy-confirm", StrictPrivacyConfirmController)

import SubNavScrollController from "./sub_nav_scroll_controller"
application.register("sub-nav-scroll", SubNavScrollController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
